export const addEmployeeDefaultValues = {
  prcpfType: "",
  passCode: "",
  accountNo: "",
  bankName: "",
  contributionCode: "",
  paymentMode: "",
  remarks: "",
  otDaySalary: 0,
  otHourlySalary: 0,
  oT1PayRate: 0,
  oT2PayRate: 0,
  oT3PayRate: 0,
  defaultShift : "",
  haveOverTimePay: true,
  designationCode: "",
  departmentCode: "",
  passExpiryDate: "",
  passIssueDate: "",
  prDate: "",
  joinDate: "",
  confirmationDate: "",
  probationPeriodEnd: "",
  probationPeriodStart: "",
  icno: "",
  finNumber: "",
  uniqueId: "",
  daySalary: 0,
  hourlySalary: 0,
  basicSalary: 0,
  salaryType: "",
  sdlBreakdown: "",
  contributesSDL: "",
  cpfEntitled: "",
  residentialType: "",
  identification: "",
  postalCode: "",
  country: "",
  address3: "",
  address2: "",
  address1: "",
  isActive: true,
  relationship: "",
  emergencyContactPerson: "",
  academicQualification: "",
  hpno: "",
  personalEmail: "",
  email: "",
  bloodGroup: "",
  race: "",
  religion: "",
  nationality: "",
  placeOfBirth: "",
  dob: "",
  maritalStatus: "",
  gender: "",
  fullName: "",
  otPaidInDays: 0,
  employeeCode: 0,
  officeNo: "",
  // createUser: "",
  // createDate: "",
  // modifyUser: "",
  // modifyDate: "",
  locationCode: "",
  mode: "I",
  dateFormat: "dd/mm/yyyy",
  employeePhoto: "",
  employeeSignature : "",
  skilledOrUnSkilled: "S",
  employmentStatus: 1,
  isSupervisor: false,
  resignedDate: "",
  jobTitle: "",
  workDayPerWeek: 0,
  reportTo: "",
  haveLoginPermission: true,
  dailyAllowance: 0,
  haveOverTimePayForExtraHours: true,
  haveNeedAttendance: true,
  restDay: "",
  loginUserName: "",
  aliasName: "",
  preferedName: "",
  groups: "",
  surpervisorName: "",
  payrollFrequency: "",
  skillSet: "",
  workingHoursPerDay: 8,
  // noofworkingDaysPerWeek: 6,
  basicPayAmountType: "SGD",
  superAdmin: false,
  workingTimingPerDay: "8",
  userSecurity: "",
  claimsTypes: "0",
  lengthofNoticePeriod: "60",
  fundDonation: "",
  clockInAndOutOnMobile: "True",
  jobGrade: "",
  haveLessTimeDeduction: false,
  workingMode: "",
  netcoTrade: "",
  excludeTime: "false",
  momTrade: "",
  grade: "",
  batch: "",
  supplierCompany: "",
  workExperienceDetails: [],
  inventoryDetails: [],
  employeesLeaveDetails: [],
  allowanceDetails: [],
  deductionDetails: [],
  employeeLogin: [
    {
      isActive: true,
      isLock: false,
      deviceId: ""
    },
  ],
  otherVisaDetails: [],
  accommodationDetail: [],
  employeeKidsDetail: [],
  dependantDetail: [],
  localContactNumber: "",
  overseasContactNumber: "",
  eatingHabit: "",
  havingKids: false,
  havingDependants: false,
  accommodationByCompany: false,
  language1: "",
  language2: "",
  language3: "",
  fatherName: "",
  motherName: "",
  publicHolidayGroup: "1",
  alternateWorkingHours: [],
  contractExpiryDate: "",
  nsEligible: false,
  contractType: "",
  employmentType: "",
  mondayWorkingMode: "1",
  tuesdayWorkingMode: "1",
  wednesdayWorkingMode: "1",
  thursdayWorkingMode: "1",
  fridayWorkingMode: "1",
  saturdayWorkingMode: "0.5",
  sundayWorkingMode: "0",
  employeeType: "",
  projectCode: "",
  extraHoursRate: 0,
  haveFullPay: false,
  cpfAccountDetails: [
    {
      id: 0,
      employeeCode: 0,
      nric: "",
      employeeCPFAccountNumber: "",
      additionalCPFAccount: "",
      employerCPFAccount: "",
      cpfStatus: "",
      autoDetectCPF: false,
      includeIR8ASubmission: false,
      sdfRequired: false,
      voluntaryCPFContribution: 0,
      employeeAmount: 0,
      employerAmount: 0,
      isActive: true,
      isLock: false,
    },
  ],
};

export const EmployeeFieldMapping = {
  prcpfType: 0,
  passCode: 1,
  accountNo: 3,
  bankName: 3,
  contributionCode: 0,
  paymentMode: 3,
  otDaySalary: 3,
  otHourlySalary: 3,
  oT1PayRate: 3,
  oT2PayRate: 3,
  oT3PayRate: 3,
  haveOverTimePay: 3,
  designationCode: 0,
  departmentCode: 0,
  passExpiryDate: 1,
  passIssueDate: 1,
  prDate: 0,
  joinDate: 0,
  confirmationDate: 0,
  probationPeriodEnd: 0,
  probationPeriodStart: 0,
  icno: 0,
  finNumber: 0,
  uniqueId: 0,
  daySalary: 3,
  hourlySalary: 3,
  basicSalary: 3,
  salaryType: 3,
  sdlBreakdown: 0,
  contributesSDL: 0,
  cpfEntitled: 0,
  residentialType: 0,
  identification: 0,
  postalCode: 4,
  country: 4,
  address3: 4,
  address2: 4,
  address1: 4,
  isActive: 0,
  relationship: 4,
  emergencyContactPerson: 4,
  academicQualification: 4,
  hpno: 4,
  personalEmail: 4,
  email: 4,
  bloodGroup: 4,
  race: 0,
  religion: 0,
  nationality: 4,
  placeOfBirth: 4,
  dob: 4,
  maritalStatus: 0,
  gender: 0,
  fullName: 0,
  otPaidInDays: 3,
  employeeCode: 0,
  officeNo: 4,
  // createUser: "",
  // createDate: "",
  // modifyUser: "",
  // modifyDate: "",
  locationCode: 0,
  employeePhoto: 4,
  skilledOrUnSkilled: 0,
  employmentStatus: 0,
  isSupervisor: 0,
  workDayPerWeek: 0,
  reportTo: 0,
  groups: 0,
  workingHoursPerDay: 0,
  noofworkingDaysPerWeek: 0,
  haveLessTimeDeduction: 3,
  workingMode: 0,
  netcoTrade: 0,
  excludeTime: 0,
  momTrade: 0,
  supplierCompany: 0,
  workExperienceDetails: 10,
  inventoryDetails: 11,
  employeesLeaveDetails: 6,
  allowanceDetails: 5,
  deductionDetails: 5,
  otherVisaDetails: 12,
  accommodationDetail: 13,
  employeeKidsDetail: 14,
  dependantDetail: 15,
  localContactNumber: 4,
  overseasContactNumber: 4,
  eatingHabit: 4,
  havingKids: 4,
  havingDependants: 4,
  accommodationByCompany: 4,
  motherName: 4,
  alternateWorkingHours: 7,
  contractExpiryDate: 0,
  nsEligible: 0,
  contractType: 0,
  employmentType: 0,
  mondayWorkingMode: 7,
  tuesdayWorkingMode: 7,
  wednesdayWorkingMode: 7,
  thursdayWorkingMode: 7,
  fridayWorkingMode: 7,
  saturdayWorkingMode: 7,
  sundayWorkingMode: 7,
  employeeType: 0,
  projectCode: 0,
  extraHoursRate: 3,
  haveFullPay: 3,
  cpfAccountDetails: 3,
  educationalQualificationList: 8,
  certificationsDetails: 9,
  employeeLogin: 0
};
